import { css } from '@emotion/react';
import { FlexStyle } from './FlexStyles';
import { theme, themeOld } from './theme';

export const DropdownItemStyle = ({ active }: { active?: boolean } = { active: false }) => [
	FlexStyle({ alignItemsCenter: true }),
	css`
		height: 36px;
		padding: 8px 16px 8px 12px;
		text-decoration: none;
		color: ${theme.color.text['400']};
		white-space: nowrap;
		font-size: 14px;
		font-weight: 400;
		border-radius: 8px;
		margin: 2px 8px;

		&:hover {
			cursor: pointer;
			background: ${theme.color.primary['50']};
			color: ${theme.color.text['400']};
			text-decoration: none;
		}

		${!!active &&
		css`
			color: ${theme.color.primary['400']};

			&:hover {
				color: ${theme.color.primary['400']};
			}
		`}
	`,
];

export const DropDownItemIcon = ({ active }: { active?: boolean } = { active: false }) => css`
	margin-right: 16px;
	display: flex;
	color: ${active ? themeOld.COLOR_BASE_GREEN : themeOld.COLOR_DARK_GREEN_LIGHTEN_23};
`;
